export default __webpack_public_path__ + "static/media/img-1.04d7b6cd.jpg";